var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconEth = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 20,
  viewBox: "0 0 13 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.00688 13.7966V7.64673L0 10.278L6.00688 13.7966Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00691 7.22392V0.00292969L0.193604 9.77026L6.00691 7.22392Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.39404 0V7.22397L12.289 9.80633L6.39404 0Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.39404 7.64673V13.7968L12.4051 10.2798L6.39404 7.64673Z",
  fill: "currentColor"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.00676 19.98V15.0336L0.0402832 11.5403L6.00676 19.98Z",
  fill: "currentColor"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.39404 19.98L12.3605 11.5403L6.39404 15.0336V19.98Z",
  fill: "currentColor"
})));
export default SvgIconEth;